// Enums for storage keys used in typedStorage

import type { DrawingData } from "@/shared/types/drawing";

export enum LocalStorageKey {
  AnonId = 'id',
  HasVisited = 'hasVisited',
  LastAnalysisSettings = 'lastAnalysisSettings',
}

export enum SessionStorageKey {
  DrawingData = 'drawingData',
  DrawingFiles = 'drawingFiles',
  PendingDrawings = 'pendingDrawings',
}

// Type for pending drawings from analysis
export interface PendingDrawing {
  drawingId: string;
  fileId: string;
  fileName: string;
  startedAt?: string;
}
// Type for last used analysis settings
export interface LastAnalysisSettings {
  templateId: string;
  modelId: string;
  fileHandling: 'single' | 'multiple';
  timestamp: number;
}

// Storage models for use with typedStorage
export interface LocalStorageModel {
  [LocalStorageKey.AnonId]: string;
  [LocalStorageKey.HasVisited]: boolean;
  [LocalStorageKey.LastAnalysisSettings]: LastAnalysisSettings
  [LocalStorageKey.HasVisited]: boolean;
}

export interface SessionStorageModel {
  [SessionStorageKey.DrawingData]: DrawingData;
  [SessionStorageKey.DrawingFiles]: {name:string, type:string, data:string}[];
  [SessionStorageKey.PendingDrawings]: PendingDrawing[];
}
